import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButtonStyled } from '../../ActionsCard/styled';
import { ResetPanelButtonStyled } from '../../styled';

interface ButtonResetFiltersProps {
    handleResetClauseFilter: (resetFilters: number) => void;
}

const ButtonResetFilters: FC<ButtonResetFiltersProps> = ({ handleResetClauseFilter }) => {
    const { t } = useTranslation('dashboard');

    return (
        <ResetPanelButtonStyled onClick={() => handleResetClauseFilter(1)} type="button">
            <CloseButtonStyled sx={{ width: '18px', height: '18px' }} />
            {t('filter.resetFilters')}
        </ResetPanelButtonStyled>
    );
};

export default ButtonResetFilters;
